import { apiRoutes } from '../../api-routes';
import { publicHttpClient } from '../../util/http-client';
import type { ActivateResponse } from './activate-user-fn';

export interface MomoActivatePayload {
  checksum: string;
  name: string;
  mobile: string;
  email: string;
}

export const momoActivateFn = async (body: MomoActivatePayload) => {
  const response = await publicHttpClient.post<ActivateResponse>(
    apiRoutes.auth.momo_activate,
    body
  );
  return response.data;
};
